import { RootState } from '@src/store';
import { createSelector } from '@reduxjs/toolkit';
import { ICreateOrderInitialState } from './types';

const CreateOrderReducer = (state: RootState): ICreateOrderInitialState => state.CreateOrderReducer;
const CreateOrderState = createSelector([CreateOrderReducer], (state) => state);

export const selectReadOnlyTakeOff = createSelector([CreateOrderState], (state) => state.readOnlyTakeOff);
export const selectTakeOffLocation = createSelector([CreateOrderState], (state) => state.takeOffLocation);
export const selectDestinationLocation = createSelector([CreateOrderState], (state) => state.destinationLocation);
export const selectPath = createSelector([CreateOrderState], (state) => {
  const path = [];

  const location1 = state.takeOffLocation;
  const location2 = state.destinationLocation;

  if (location1) {
    path.push({ lat: Number(location1.latitude), lng: Number(location1.longitude) });
  }
  if (location2) {
    path.push({ lat: Number(location2.latitude), lng: Number(location2.longitude) });
  }

  return path;
});